import { IMoveOrdersButton } from "../../../interfaces/IMoveOrdersButton";
import { globalTheme } from "../../../styles";
import { CustomerProfileIcon, WarningIcon } from "../../Icon";
import { PickAndPackIcon } from "../../Icon/PickAndPackIcon";
import { RefreshIcon } from "../../Icon/RefreshIcon";
import { UnShippedIcon } from "../../Icon/UnShippedIcon";

export const moveShipmentActionItems = ({
  handleOnClickPicked,
  handleOnClickUnPicked,
  handleOnClickAssigned,
  handleOnClickIssue,
  handleOnClickOnHold,
  handleOnClickCancelled,
  handleOnClickPickAndPack,
}: {
  handleOnClickPicked?: () => void;
  handleOnClickUnPicked?: () => void;
  handleOnClickAssigned?: () => void;
  handleOnClickIssue?: () => void;
  handleOnClickOnHold?: () => void;
  handleOnClickCancelled?: () => void;
  handleOnClickPickAndPack?: () => void;
}): IMoveOrdersButton[] => {
  const buttons: IMoveOrdersButton[] = [
    {
      label: "Unpicked",
      value: "UN_PICKED",
      variant: "outlined",
      size: "large",
      onClick: handleOnClickUnPicked,
      disable: false,
      color: globalTheme.blue,
      borderColor: globalTheme.blue,
      startIcon: <UnShippedIcon />,
      iconOpacity: 1,
    },
    {
      label: "Picked",
      value: "PICKED",
      variant: "outlined",
      size: "large",
      onClick: handleOnClickPicked,
      disable: false,
      color: globalTheme.blue,
      borderColor: globalTheme.blue,
      iconOpacity: 1,
    },
    {
      label: "Assigned",
      value: "ASSIGNED",
      variant: "outlined",
      size: "large",
      onClick: handleOnClickAssigned,
      disable: true,
      color: globalTheme.primaryColor,
      borderColor: globalTheme.secondaryColor,
      startIcon: <CustomerProfileIcon />,
      iconOpacity: 1,
    },
    {
      label: "Issue",
      variant: "outlined",
      value: "ISSUES",
      size: "large",
      onClick: handleOnClickIssue,
      disable: false,
      color: globalTheme.red,
      borderColor: globalTheme.red,
      startIcon: <WarningIcon />,
      iconOpacity: 1,
    },
    {
      label: "OnHold",
      variant: "outlined",
      value: "ON_HOLD",
      size: "large",
      onClick: handleOnClickOnHold,
      disable: false,
      color: globalTheme.orange,
      borderColor: globalTheme.orange,
    },
    {
      label: "Cancelled",
      variant: "outlined",
      value: "CANCELLED",
      size: "large",
      onClick: handleOnClickCancelled,
      disable: false,
      color: globalTheme.red,
      borderColor: globalTheme.red,
    },
  ];

  const shipmentTab = localStorage.getItem("shipmentsTab");

  if (shipmentTab === "CLICK_AND_COLLECT" || shipmentTab === "SHIPPED") {
    buttons.splice(2, 0, {
      label: "Pick and Pack",
      value: "PICK_AND_PACK",
      variant: "outlined",
      size: "large",
      onClick: handleOnClickPickAndPack,
      disable: false,
      color: globalTheme.primaryColor,
      borderColor: globalTheme.primaryColor,
      startIcon: <PickAndPackIcon />,
      iconOpacity: 1,
    });
  }

  return buttons;
};

export const AMAZON_WI_ACTION_BUTTON = ({ handleRefetchAmazon }: { handleRefetchAmazon?: () => void }): IMoveOrdersButton[] => [
  {
    value: "refetchAmazon",
    label: "Refetch Amazon Label",
    variant: "outlined",
    size: "large",
    color: globalTheme.activeMenu,
    borderColor: globalTheme.activeMenu,
    onClick: handleRefetchAmazon,
    disable: false,
    startIcon: <RefreshIcon fill={globalTheme.activeMenu} />,
  },
];
